module.exports = "#version 300 es\r\nprecision highp float;\r\n\r\nin vec2 fs_UV;\r\n\r\nout vec4 out_Col;\r\n\r\nuniform sampler2D u_frame;\r\nuniform sampler2D u_overlay;\r\n\r\nvoid main() {\r\n\tvec4 col = texture(u_frame, fs_UV);\r\n\tvec4 col2 = texture(u_overlay, fs_UV);\r\n\tout_Col = vec4(col2.rgb + col.rgb, 1.0);\r\n\t//out_Col.rgb = col2.rgb;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/add-frag.glsl
// module id = 44
// module chunks = 0